var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"group block no-underline text-black hover:text-blue pl-4 mb-2",attrs:{"href":_vm.url},on:{"click":_vm.handleClick}},[_c('span',{staticClass:"flex p-2 rounded-tl rounded-bl",class:{'bg-white': _vm.active}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }